import { Field, TextInput, StepTitle } from "@/components/register/Fields";

const F = [
  ["full_name", "Parent / guardian full name", "text"],
  ["email", "Email address", "email"],
  ["mobile", "Mobile number", "tel"],
  ["emergency_name", "Emergency contact name", "text"],
  ["emergency_phone", "Emergency contact number", "tel"],
  ["emergency_relationship", "Relationship to player", "text"],
];

export const StepParent = ({ parent, set, errors }) => (
  <div data-testid="step-parent">
    <StepTitle eyebrow="Step 3" title="Parent / guardian" sub="Entered once — used for every child you register." />
    <div className="grid sm:grid-cols-2 gap-5">
      {F.map(([k, label, type]) => (
        <Field key={k} label={label} error={errors[k]}>
          <TextInput testid={`parent-${k.replace(/_/g, "-")}`} type={type} value={parent[k]} onChange={(e) => set(k, e.target.value)} />
        </Field>
      ))}
    </div>
  </div>
);
